<template>
  <div class="evento-container">
    <br />
    <br />

    <div class="rasgado rasgado-superior"></div>

    <!-- DECORACIÓN DE BESOS -->
    <div class="besos-decorativos">
      <img src="@/assets/beso.png" class="beso beso1" />
      <img src="@/assets/beso.png" class="beso beso2" />
      <img src="@/assets/beso.png" class="beso beso4" />
      <img src="@/assets/beso.png" class="beso beso5" />
    </div>

    <!-- BOLAS -->
    <div class="bolas-container">
      <img ref="bola1" src="@/assets/disco.png" class="bola bola-left" />
      <img ref="bola2" src="@/assets/disco.png" class="bola bola-right" />
      <img ref="bola3" src="@/assets/estre.png" class="bola bola-left1" />
    </div>

    <!-- ENCABEZADO -->
    <div class="encabezado-ubicacion">
      <div class="ornamento ornamento-left" />
      <div class="ubicacion-linea">
        <div ref="lineaDecorativa" class="linea-decorativa" />
      </div>
    </div>

    <!-- ================= CEREMONIA RELIGIOSA ================= -->
    <div class="evento-card">
      <div class="icono-evento">
        <img src="@/assets/iglesiapng.png" alt="Ícono ceremonia" />
      </div>

      <p class="evento-tipo">Ceremonia Religiosa</p>

      <div ref="imgReligiosa" class="evento-imagen-wrapper">
        <img
          src="@/assets/ChatGPT Image 7 jun 2026, 07_15_33 p.m..png"
          class="imagen-fondo"
        />
        <img src="@/assets/marco.png" class="marco-decorativo" />
      </div>

      <div ref="infoReligiosa" class="evento-info">
        <p class="evento-lugarparroquia">Parroquia de Fátima</p>

        <p class="evento-direccion">
          <br /><br />
        C. Isidro Huarte SN, Cuauhtémoc  <br /><br /> Morelia, Michoacán. 
       
        </p>

        <p class="hora">6:00 PM</p>

        <a
          href="https://maps.app.goo.gl/An3Dy3E8rmyxs4G5A"
          class="btn-mapa"
          target="_blank"
        >
          ¿Cómo llegar?
        </a>
      </div>

    </div>

    <!-- ================= CELEBRACIÓN ================= -->
    <div class="evento-card">
      <div class="icono-evento">
        <img src="@/assets/iglesiapng.png" alt="Ícono celebración" />
      </div>

      <p class="evento-tipo">Celebración</p>

      <div ref="imgCeremonia" class="evento-imagen-wrapper">
        <img
          src="@/assets/ChatGPT Image 7 jun 2026, 07_24_06 p.m..png"
          class="imagen-fondo"
        />
        <img src="@/assets/marco.png" class="marco-decorativo" />
      </div>

      <div ref="infoCeremonia" class="evento-info">
        <p class="evento-lugarparroquia">Hacienda Figueroa</p>

        <p class="evento-direccion">
          <br /><br />
          Calle Guaymas S/N Colonia San Juanito Itzícuaro
          <br /><br />
Morelia, Michoacán.      </p>

        <p class="hora">7:00 PM</p>

        <a
          href="https://maps.app.goo.gl/n4w6HYPdyBAgakB37"
          class="btn-mapa"
          target="_blank"
        >
          ¿Cómo llegar?
        </a>

        <p class="mismo-lugar-nota">
        </p>
      </div>

      <div ref="lineaCentralRef" class="linea-central" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'EventoSection',

  setup() {
    const infoReligiosa = ref(null)
    const imgReligiosa = ref(null)

    const infoCeremonia = ref(null)
    const imgCeremonia = ref(null)

    const lineaCentralRef = ref(null)
    const lineaDecorativa = ref(null)

    const bola1 = ref(null)
    const bola2 = ref(null)
    const bola3 = ref(null)

    const animarElemento = (element) => {
      gsap.fromTo(
        element,
        {
          opacity: 0,
          y: 80,
          scale: 0.9,
          filter: 'blur(12px)'
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          filter: 'blur(0px)',
          duration: 1.6,
          ease: 'power4.out'
        }
      )
    }

    const animarLinea = (element) => {
      gsap.fromTo(
        element,
        {
          scaleY: 0,
          opacity: 0
        },
        {
          scaleY: 1,
          opacity: 1,
          transformOrigin: 'top center',
          duration: 1.6,
          ease: 'power4.out'
        }
      )
    }

    const rotarBola = (element) => {
      gsap.fromTo(
        element,
        {
          opacity: 0,
          scale: 0.4,
          rotate: -180
        },
        {
          opacity: 1,
          scale: 1,
          rotate: 0,
          duration: 2,
          ease: 'expo.out'
        }
      )

      gsap.to(element, {
        rotate: 360,
        duration: 30,
        ease: 'none',
        repeat: -1
      })
    }

    onMounted(() => {
      const observar = (el, accion) => {
        if (!el?.value) return

        const observer = new IntersectionObserver(
          (entries, obs) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                accion()
                obs.unobserve(entry.target)
              }
            })
          },
          {
            threshold: 0.22
          }
        )

        observer.observe(el.value)
      }

      observar(imgReligiosa, () =>
        animarElemento(imgReligiosa.value)
      )

      observar(infoReligiosa, () =>
        animarElemento(infoReligiosa.value)
      )

    

      observar(imgCeremonia, () =>
        animarElemento(imgCeremonia.value)
      )

      observar(infoCeremonia, () =>
        animarElemento(infoCeremonia.value)
      )

  

      observar(lineaCentralRef, () =>
        animarLinea(lineaCentralRef.value)
      )

      observar(bola1, () =>
        rotarBola(bola1.value)
      )

      observar(bola2, () =>
        rotarBola(bola2.value)
      )

      observar(bola3, () =>
        rotarBola(bola3.value)
      )
    })

    return {
      infoReligiosa,
      imgReligiosa,

      infoCeremonia,
      imgCeremonia,

      lineaCentralRef,
      lineaDecorativa,

      bola1,
      bola2,
      bola3
    }
  }
}
</script>

<style scoped>
.evento-container {
  background-image: url('../assets/fondoo.avif');
  color: #fff;
  margin-top: -20px;
  margin-bottom: -20px;
  background-size: cover;
  background-position: center;
  padding-bottom: 40px;
  position: relative;
}

.encabezado-ubicacion {
  text-align: center;
  margin-bottom: 16px;
}

.linea-decorativa {
  width: 40px;
  height: 1px;
  background-color: #413d3d;
  margin: 8px auto;
  transform: scaleX(0);
}

.evento-card {
  max-width: 400px;
  margin: 0 auto 40px;
  text-align: center;
  padding: 0px 0;
  border-radius: 12px;
  overflow: hidden;
}

.icono-evento {
  margin-top: 20px;
}

.icono-evento img {
  width: 100px;
  height: auto;
  display: inline-block;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.2));
}

.evento-imagen-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.25));
}

.imagen-fondo {
  width: 80%;
  max-height: 200px;
  object-fit: cover;
  display: block;
  border-radius: 2px;
  box-shadow: 0 10px 25px rgba(237, 233, 233, 0.016);
  position: relative;
  z-index: 1;
  margin: 0 auto;
}

.evento-imagen-wrapper::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 10%;
  width: 80%;
  height: 30%;
  background: linear-gradient(to top, rgba(255, 255, 255, 0), transparent);
  pointer-events: none;
  z-index: 0;
  border-radius: 2px;
}

.marco-decorativo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  mix-blend-mode: lighten;
  opacity: 0.8;
  filter: brightness(0.4);
}

.evento-info {
  padding: 16px;
  color: #454141d9;
  opacity: 0;
}

.hora {
  font-family: 'padres';
  font-size: 19px;
  margin-bottom: 4px;
  font-weight: 800;
  color: #282626;
}

.evento-tipo {
  font-family: 'british', sans-serif;
  font-size: 34px;
  margin-bottom: 12px;
  color: #434040;
}

.evento-lugar {
  font-size: 26px !important;
  font-family: 'british', sans-serif;
  color: #070707;
  font-weight: bold;
  margin-bottom: 5px;
}

.evento-lugarparroquia {
  font-size: 25px !important;
  font-family: 'british', sans-serif;
  color: #070707;
  font-weight: bold;
  margin-bottom: 5px;
}

.evento-direccion {
  font-family: 'padres';
  font-size: 19px;
  line-height: 1;
  font-weight: 400;
  color: #1b1a1ac6;
}

.btn-mapa {
  margin-top: 10px;
  background: #000000c5;
  color: rgb(255, 255, 255);
  font-size: 14px;
  padding: 6px 16px;
  text-decoration: none;
  font-family: 'padres';
  border-radius: 18px;
  font-weight: 800;
  display: inline-block;
  transition: background 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
}

.btn-mapa:hover {
  background: #c49b9b;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.35);
}

/* Estilo estilizado para la nueva nota aclaratoria */
.mismo-lugar-nota {
  font-family: 'padres', sans-serif;
  font-size: 15px;
  color: #0f0f0fce;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.3;
  max-width: 85%;
  margin-top:20px;
  margin-left: auto;
  margin-right: auto;
}

.linea-central {
  width: 2px;
  height: 60px;
  margin: 20px auto;
  background-color: #ffffff;
  transform: scaleY(0);
}

.besos-decorativos {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
  z-index: 3;
}

.beso {
  filter: brightness(0.4);
  position: absolute;
  opacity: 0.32;
}

.beso1 {
  top: 60px;
  left: 15%;
  width: 50px;
  transform: rotate(-15deg);
}

.beso2 {
  top: 200px;
  right: 10%;
  width: 70px;
  transform: rotate(20deg);
}

.beso3 {
  top: 400px;
  left: 50%;
  width: 90px;
  transform: rotate(-30deg);
}

.beso4 {
  bottom: 100px;
  left: 25%;
  width: 60px;
  transform: rotate(8deg);
}

.beso5 {
  bottom: 30px;
  right: 20%;
  width: 40px;
  transform: rotate(-10deg);
}

.bolas-container {
  position: relative;
  z-index: 3;
}

.bola {
  position: absolute;
  top: -40px;
  width: 140px;
  opacity: 0.6;
  z-index: 1;
}

.bola-left {
  left: -50px;
  transform: rotate(-15deg);
}

.bola-right {
  right: -50px;
  top: 565px;
  transform: rotate(15deg);
}

.bola-left1 {
  left: -50px;
  top: 1450px;
  width:100px !important;
  transform: rotate(-15deg);
}

/* ==============asdasdasdasdadsasdsd===========
   RASGADOS
========================= */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;
  background: #ffffff;
  z-index: 3;
  margin-top: -40px;
  pointer-events: none;
}

.rasgado-superior {
  top: 0;
  background: #ffffff;
  clip-path: polygon(
    0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%,
    100% 0%, 0% 0%
  );
}

.rasgado-inferior {
  bottom: 0;
  background-color: #ffffff;
  clip-path: polygon(
    0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%,
    100% 100%, 0% 100%
  );
}
</style>